import { Component } from '@angular/core';

@Component({
	templateUrl: './privacy.component.html',
	styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent {
	constructor() {}
}
